<template>
    <div class="content">
        <el-container>
            <el-header style="height: auto"><CommonHeader :innerWidth="innerWidth" /></el-header>
            <!-- <div class="block">
                <el-image class="headimg"  :fit="cover"
                    :src="require('../assets/images/head.jpg')"></el-image>
            </div> -->
                 <!-- 导航链接：首页:height="innerWidth > 1023?'':innerWidth < 767?'12em':'18em'" -->
   
            <div class="block">
                <el-carousel :height="innerWidth > 1023?'':innerWidth < 767?'12em':'18em'"  indicator-position="none">
                <el-carousel-item v-for="item in swiperList" :key="item">
                    <el-image class="headimg"  :fit="cover"
                    :src="item"></el-image>
                </el-carousel-item>
                </el-carousel>
            </div>
            
            <!-- <router-view></router-view> -->
            <!-- <Detail /> -->
           <!-- <EnterpriseDisplay/> -->
                <!-- 主内容区 -->
            <div class="main-content">
                <!-- 默认显示 Detail 组件 -->
                <Detail v-if="!$route.meta.hideDetail" />

                <!-- 路由视图（当路由匹配时显示） -->
                <router-view v-if="$route.meta.showRouterView" />
            </div>

            <el-footer style="padding: 0;">
                <CommonFooter />
            </el-footer>
        </el-container>

    </div>
</template>

<script>
import { getlist,recommendList,swiperList,cityList  } from '../api/api';
import CommonHeader from "../components/CommonHeader.vue";
import CommonFooter from "../components/CommonFooter.vue";

// 引入 
import Detail from "../views/Detail.vue";
import EnterpriseDisplay from "../views/EnterpriseDisplay.vue";

export default {
    data() {
        return {
            swiperList:[],
            innerWidth: window.innerWidth,
        }
    },
    components: {
        CommonHeader,
        CommonFooter,
        Detail,
        EnterpriseDisplay
    },
    computed: {
        isMobile() {
            return this.innerWidth < 768;
        }
    },
    methods: {
        async getswiperList(){
            const data = {
                token: "",
                wxapp_id: '10001'
            }
            swiperList(data).then(response => {
                console.log("swiperList",response);
                this.swiperList=response.data.data.lists
            }).catch(error => {
                    console.error(error);
            });
            // https://ys.it80.vip/api/article/pic?token=&wxapp_id=10001
        },
        updateInnerWidth() {
            this.innerWidth = window.innerWidth;
        },
    },
    created() {
        this.getswiperList()
        window.addEventListener('resize', this.updateInnerWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateInnerWidth);
    }
}
</script>

<style>
.el-header {
    padding: 0;
}

@media (max-width: 767px) {
    .headimg{
        width: 100vw;
        height: 12em;
    }
}

/* 平板样式 */
@media (min-width: 768px) and (max-width: 1023px) {
    .headimg{
        width: 100vw;
        height: 18em;
    }
}

/* 桌面样式 */
@media (min-width: 1024px) {
    .headimg{
        width: 100vw;
        /* height: 22em; */
    }
    .el-image__error, 
    .el-image__inner,
    .el-image__placeholder {
        height: auto;
    }
}


</style>